import { Row, Col } from 'react-bootstrap'
import { useObfuscatedContact } from './useObfuscatedContact'

const TermsOfService = () => {
    const { email1, address } = useObfuscatedContact()
    return (
        <Row className="legalPage mx-0" id="terms">
            <Row className="legalContent mx-0 justify-content-center">
                <Col className="col-12 col-lg-8">
                    <h1 className="legalTitle">Terms of Service</h1>
                    <p className="legalDate">Last updated: January 2026</p>
                    
                    <div className="legalSection">
                        <h2>1. Acceptance of Terms</h2>
                        <p>
                            By accessing or using the Linko Labs LLC website and services, you agree to be 
                            bound by these Terms of Service. If you do not agree to these terms, please 
                            do not use our services.
                        </p>
                    </div>

                    <div className="legalSection">
                        <h2>2. Services</h2>
                        <p>
                            Linko Labs LLC provides custom software development, AI integration, and 
                            technical consulting services. All services are provided under separate 
                            written contracts that specify scope, deliverables, timelines, and payment terms.
                        </p>
                    </div>

                    <div className="legalSection">
                        <h2>3. Client Responsibilities</h2>
                        <p>Clients agree to:</p>
                        <ul>
                            <li>Provide accurate and complete information necessary for project execution</li>
                            <li>Make timely payments according to agreed milestone schedules</li>
                            <li>Provide timely feedback and approvals as required</li>
                            <li>Maintain confidentiality of any proprietary information shared</li>
                        </ul>
                    </div>

                    <div className="legalSection">
                        <h2>4. Payment Terms</h2>
                        <p>
                            Payment terms are specified in individual project contracts. Generally, 
                            projects are structured with milestone-based payments. Late payments may 
                            result in project delays or suspension until payment is received.
                        </p>
                    </div>

                    <div className="legalSection">
                        <h2>5. Intellectual Property</h2>
                        <p>
                            Upon full payment, clients receive ownership of custom code and deliverables 
                            created specifically for their project, unless otherwise specified in the 
                            project contract. Pre-existing tools, libraries, and frameworks remain the 
                            property of their respective owners.
                        </p>
                    </div>

                    <div className="legalSection">
                        <h2>6. Confidentiality</h2>
                        <p>
                            Both parties agree to maintain confidentiality of proprietary information 
                            shared during the course of the engagement. This obligation survives the 
                            termination of any project agreement.
                        </p>
                    </div>

                    <div className="legalSection">
                        <h2>7. Limitation of Liability</h2>
                        <p>
                            Linko Labs LLC's liability is limited to the amount paid for services 
                            under the applicable contract. We are not liable for indirect, incidental, 
                            or consequential damages arising from the use of our services.
                        </p>
                    </div>

                    <div className="legalSection">
                        <h2>8. Termination</h2>
                        <p>
                            Either party may terminate a project agreement according to the terms 
                            specified in the individual contract. Payment is due for all work completed 
                            up to the termination date.
                        </p>
                    </div>

                    <div className="legalSection">
                        <h2>9. Governing Law</h2>
                        <p>
                            These Terms of Service are governed by the laws of the State of New York, 
                            United States, without regard to conflict of law principles.
                        </p>
                    </div>

                    <div className="legalSection">
                        <h2>10. Contact Information</h2>
                        <p>
                            For questions about these Terms of Service, please contact us at:
                        </p>
                        <p>
                            {address?.company}<br />
                            {address?.street}<br />
                            {address?.city}<br />
                            Email: {email1}
                        </p>
                    </div>
                </Col>
            </Row>
        </Row>
    )
}

export default TermsOfService
